module.exports = __webpack_public_path__ + "img/brand-pic-02.273bc8cd.png";